import { Fragment } from "react";

import Home from "./views/Home";

console.log("💡 Running v2.0.2");

export const App = () => {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
};
